import momentTZ from "moment-timezone";
import React from "react";
import {
  APPROVE_STATUS,
  APPROVE_STATUS_COLOR_CLASS,
  SEND_STATUS,
  SEND_STATUS_COLOR_CLASS,
} from "./constants";

export function formatDate(date) {
  return momentTZ(date).tz("Asia/Bangkok").format("DD MMM YY");
}

export function formatSendStatusClass(sendStatus) {
  return sendStatus === SEND_STATUS.sent
    ? SEND_STATUS_COLOR_CLASS.sent
    : sendStatus === SEND_STATUS.pending
    ? SEND_STATUS_COLOR_CLASS.pending
    : undefined;
}

export function formatSendStatus(sendStatus, ml) {
  return sendStatus === SEND_STATUS.pending ? (
    <i className={`ml-${ml} fas fa-user-clock fa-lg`} />
  ) : sendStatus === SEND_STATUS.sent ? (
    <i className={`ml-${ml} fas fa-paper-plane fa-lg`} />
  ) : (
    " - "
  );
}

export function formatApproveStatusClass(approveStatus) {
  return approveStatus === APPROVE_STATUS.approved
    ? APPROVE_STATUS_COLOR_CLASS.approved
    : approveStatus === APPROVE_STATUS.rejected
    ? APPROVE_STATUS_COLOR_CLASS.rejected
    : approveStatus === APPROVE_STATUS.pending
    ? APPROVE_STATUS_COLOR_CLASS.pending
    : undefined;
}

export function formatApproveStatus(approveStatus, ml) {
  return approveStatus === APPROVE_STATUS.pending ? (
    <i className={`ml-${ml} fas fa-user-clock fa-lg`} />
  ) : approveStatus === APPROVE_STATUS.approved ? (
    <i className={`ml-${ml} fas fa-check-circle fa-lg`} />
  ) : approveStatus === APPROVE_STATUS.rejected ? (
    <i className={`ml-${ml} fas fa-times-circle fa-lg`} />
  ) : (
    "-"
  );
}

export function isDateAvailable(hire, resign, date) {
  //expected date format 'YYYY-MM-DDT17:00:00.000Z'
  let work_date = new Date(date).getTime();
  const _resign = new Date(resign != null ? `${resign}T00:00:00`:'2999-12-31T00:00:00').getTime();
  const _hire = new Date(`${hire}T00:00:00`).getTime();

  if (work_date < _hire || work_date >= _resign ) {
    console.log(`Origin: work_date ${date}, resign ${resign}, hire ${hire}`);
    console.log(`${work_date} < ${_hire} or >= ${_resign}`);
    return false;
  } else {
    return true;
  }
}
